export let baseJSON = [
  {
    title: '案例亮点',
    moduleList: [
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点2',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点3',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点4',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点5',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '案例亮点6',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
    ],
  },
  {
    title: '案例亮点',
    moduleList: [
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点1'
      },
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点2'
      },
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点3'
      },
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点4'
      },
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点5'
      },
      {
        imgUrl: require('@/assets/img/map.png'),
        chtitle: '案例亮点6'
      },
    ],
  },
];
